import selectAccessTokenData from "@/utils/select-access-token-data";
import { useCookies } from "react-cookie";

const useAccessTokenData = () => {
  const [cookies] = useCookies(['accessToken']);
  return cookies.accessToken ? selectAccessTokenData(cookies.accessToken) : undefined;
};

export default useAccessTokenData;
